module.exports = __webpack_public_path__ + "static/media/ic_star_voted-web.7e552937.png";